import { IPatch, IPatchNotes, IPatchNotesComponent } from '../_types/interfaces';


const getLocalPatchNotes = async (serviceName: string): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => 
        resolve("Version:2.0.0.0\nКакие-то изменения" + serviceName), 1000));
};

const getLocalPatchNotesService = async (serviceName: string): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => 
        resolve("Version:2.0.0.0\nКакие-то изменения" + serviceName), 1000));
};

const getGlobalPatchNote = async (uriService: string, serviceName: string): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => 
        resolve("Version:2.0.0.0\nКакие-то изменения\n\nVersion:2.1.0.0\nКакие-то изменения" 
            + uriService 
            + serviceName), 1000));
};

export const fakePatchNotesService: IPatchNotesComponent = {
    getLocalPatchNotes,
    getLocalPatchNotesService,
    getGlobalPatchNote
};